import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, Select } from '@mui/material'
import React, { useState } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { billingServices } from 'src/services/reservation/billing/billing.service'

export const InvalidateDocument = ({
        openInvalidate,
        setOpenInvalidate,
        idToInvalidate,
        getDocuments
    }) => {
    const translate = useTranslate()
    const notify = useNotify()
    const [selectedReason, setSelectedReason] = useState('01')
    const [loadingInvalidate, setLoadingInvalidate] = useState(false)
    const reasons = [
        {label:'Corrección de factura', value:'01'},
        {label:'Factura emitida por error', value:'02'},
        {label:'Cancelación de reserva/servicio', value:'03'}
    ]

    const onInvalidate = async () =>{
        setLoadingInvalidate(true)
        await billingServices.invalidateDocument(idToInvalidate, selectedReason).then(()=>{
            notify('ra.notification.invalidate_document_success',{type:'success'})
            getDocuments()
            setOpenInvalidate(false)
        }).catch(()=>{
            notify('ra.notification.invalidate_document_error',{type:'error'})
        }).finally(()=>{
            setLoadingInvalidate(false)
        })
    }
  return (
    <Dialog open={openInvalidate} onClose={()=>setOpenInvalidate(false)}>
        <DialogTitle>
            {`${translate('ra.action.invalidate')} ${translate('ra.field.document')}`}
        </DialogTitle>
        <DialogContent>
            <Grid>
                <EditInputsWrap label={translate('ra.field.intent')}>
                    <Select
                        labelId='reasons'
                        id='reasons'
                        fullWidth
                        value={selectedReason}
                        onChange={(val)=>setSelectedReason(val.target.value)}
                        size='small'
                    >
                    {reasons.map((reason, i) => (
                        <MenuItem key={i} value={reason.value}>
                            {reason?.label}
                        </MenuItem>
                    ))}
                    </Select>
                </EditInputsWrap>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button
                onClick={()=>setOpenInvalidate(false)}
            >
                {translate('ra.action.cancel')}
            </Button>
            <LoadingButton
                onClick={onInvalidate}
                variant='contained'
                loading={loadingInvalidate}
            >
                {translate('ra.action.to_confirm')}
            </LoadingButton>
        </DialogActions>
    </Dialog>
  )
}